var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", {
      staticClass: "table dt-responsive",
      staticStyle: {
        "border-collapse": "collapse",
        "border-spacing": "0",
        width: "100%"
      },
      attrs: { id: _vm.table_container }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }